import { type InsuranceProviderLayout_insuranceProvider$key } from '@app/__generated__/InsuranceProviderLayout_insuranceProvider.graphql'
import { type InsuranceProviderLayout_query$key } from '@app/__generated__/InsuranceProviderLayout_query.graphql'
import { NavbarLink } from '@app/components'
import { Divider, Navbar } from '@mantine/core'
import { IconChevronLeft, IconMailbox, IconReportMedical } from '@tabler/icons-react'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { type FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import { AdminLayout, type AdminLayoutProps } from './AdminLayout'

const insuranceProviderFragment = graphql`
  fragment InsuranceProviderLayout_insuranceProvider on InsuranceProvider {
    name
    slug
  }
`

const queryFragment = graphql`
  fragment InsuranceProviderLayout_query on Query {
    ...AdminLayout_query
  }
`

export type InsuranceProviderLayoutProps = Omit<AdminLayoutProps, 'query'> & {
  insuranceProvider: InsuranceProviderLayout_insuranceProvider$key
  query: InsuranceProviderLayout_query$key
}

export const InsuranceProviderLayout: FC<InsuranceProviderLayoutProps> = ({
  children,
  insuranceProvider,
  query,
  title,
  ...adminLayoutProps
}) => {
  const router = useRouter()
  const insuranceProviderData = useFragment<InsuranceProviderLayout_insuranceProvider$key>(
    insuranceProviderFragment,
    insuranceProvider
  )
  const queryData = useFragment<InsuranceProviderLayout_query$key>(queryFragment, query)
  const { t } = useTranslation('admin')
  return (
    <AdminLayout
      {...adminLayoutProps}
      navbar={
        <Navbar.Section>
          <NavbarLink
            color='gray'
            IconComponent={IconChevronLeft}
            iconVariant='light'
            label={t('Back')}
            onClick={() => router.back()}
            variant='light'
          />
          <Divider color='gray.2' />
          <NavbarLink
            color='pink'
            href={`/admin/insuranceProviders/${insuranceProviderData?.slug}`}
            IconComponent={IconReportMedical}
            label={t('Insurance Provider')}
          />
          <NavbarLink
            color='violet'
            href={`/admin/insuranceProviders/${insuranceProviderData?.slug}/addresses`}
            IconComponent={IconMailbox}
            label={t('Addresses')}
          />
        </Navbar.Section>
      }
      query={queryData}
      title={`${t('Insurance Provider')} / ${insuranceProviderData?.name}${title ? ` / ${title}` : ''}`}
    >
      {children}
    </AdminLayout>
  )
}
